import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CancelInsuranceListModule } from '@app/my-zone/shared/cancel-insurance-list/cancel-insurance-list.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { OutInsurancePolicyModule } from 'outshared-lib';
import { CancelRoutingModule } from './cancel-routing.module';
import { CancelComponent } from './cancel.component';
import { CancelContainer } from './cancel.container';

@NgModule({
    imports: [
        CommonModule,
        CancelRoutingModule,
        CancelInsuranceListModule,
        PipesModule,
        OutInsurancePolicyModule,
    ],
    declarations: [
        CancelComponent,
        CancelContainer,
    ],
})
export class CancelModule { }
